var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('bank-header'),_c('div',{staticClass:"v-view"},[_c('router-view')],1),_c('bank-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }